<template>
  <div class="offer-container">
    <div class="offer-head">
      <div style="padding-right: 10px;">
        <p>{{distribution_method.display_name}}</p>
        <p class="created_at">{{ lead_distribution_method.created_at | moment-date-time}}</p>
      </div>
      <div class="detach-offer-container">
        <button class="btn" @click="detach(distribution_method.id)">Désassocier</button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions,mapGetters} from "vuex"

export default {
  name:"DistributionMethod",

  props:["lead_distribution_method"],

  computed:{
    ...mapGetters("crm", ["current_lead"]),

    distribution_method() {
      return this.lead_distribution_method.distribution_method
    }
  },

  methods: {
    detach(distribution_method_id)
    {
      this.$emit("detach-distribution-method", {
        lead_id: this.current_lead.id, 
        distribution_method_id:distribution_method_id
      })
    }
  },
}
</script>

<style scoped>
    .offer-head {
    display: flex;
    }

    .detach-offer-container {
    margin-left: auto;
    }

    .created_at {
    color: #999;
    font-style: italic;
    }
</style>



// WEBPACK FOOTER //
// client/components/CRM/DistributionMethods/Item.vue